import React from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import { getLibraryItems } from "../data/dataCIMToolkit";
import Loading from "../shared/Loading";
import Flex from "../shared/Flex";
import BreadcrumbSeparator from "../shared/BreadcrumbSeparator";
import WebLink from "../shared/WebLink";
import LibraryItemCollection from "./LibraryItemCollection";

class LibraryCategory extends React.Component {
  state = {
    items: [],
    isLoading: true
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    const items = await getLibraryItems(this.props.match.params.id, this.context.token);
    await this.setState({
      isLoading: false,
      items: items.data
    });
  };
  render() {
    if (this.state.isLoading === true)
      return (
        <AppContent>
          <Loading />
        </AppContent>
      )
    return (
      <AppContent>
        <Flex justifyContent={`flex-start`}>
          <WebLink onClick={() => this.context.navigate(`/library`)} >Library</WebLink>
          <BreadcrumbSeparator />
          <div>{this.state.items[0].categoryName}</div>
        </Flex>
        <LibraryItemCollection items={this.state.items} />
      </AppContent>
    );
  }
}

export default LibraryCategory;
